import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X, ArrowLeft } from "lucide-react";
import { useLead } from "./LeadDialog";

const HOME_URL = "https://www.progressiveturfequip.com/";

const LINKS = [
  { label: "Technology", href: "#features" },
  { label: "App", href: "#app" },
  { label: "Compare", href: "#compare" },
  { label: "Applications", href: "#applications" },
  { label: "Specs", href: "#specs" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openLead } = useLead();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-[#0A0A0A]/90 backdrop-blur-md border-b border-white/10" : "bg-transparent"}`}
    >
      <div className="px-6 md:px-12 lg:px-20 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo" className="flex items-baseline gap-2">
          <span className="font-heading text-2xl font-extrabold tracking-tight text-white">PROGRESSIVE</span>
          <span className="hidden sm:inline w-px h-5 bg-white/30" />
          <span className="hidden sm:inline font-heading text-2xl font-extrabold tracking-tight text-[#D62828]">NAVIGATOR</span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          <a href={HOME_URL} target="_top" data-testid="nav-home"
            className="flex items-center gap-1.5 text-sm font-medium text-gray-300 hover:text-white uppercase tracking-wide transition-colors">
            <ArrowLeft size={14} /> Home
          </a>
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-gray-300 hover:text-white uppercase tracking-wide transition-colors">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button data-testid="nav-quote-btn" onClick={() => openLead("quote")}
            className="border border-white/30 text-white hover:bg-white hover:text-black px-5 py-2.5 text-xs font-bold uppercase tracking-widest transition-colors">
            Request Quote
          </button>
          <button data-testid="nav-demo-btn" onClick={() => openLead("demo")}
            className="bg-[#D62828] text-white hover:bg-[#B91C1C] px-5 py-2.5 text-xs font-bold uppercase tracking-widest transition-colors shadow-[0_0_20px_rgba(214,40,40,0.4)]">
            Book a Demo
          </button>
        </div>

        <button data-testid="nav-mobile-toggle" className="lg:hidden text-white" onClick={() => setOpen((o) => !o)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
          className="lg:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-6 space-y-4">
          <a href={HOME_URL} target="_top" data-testid="nav-mobile-home"
            className="flex items-center gap-2 text-base font-medium text-gray-200 uppercase tracking-wide">
            <ArrowLeft size={16} /> Back to Homepage
          </a>
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
              className="block text-base font-medium text-gray-200 uppercase tracking-wide">{l.label}</a>
          ))}
          <button data-testid="nav-mobile-demo" onClick={() => { setOpen(false); openLead("demo"); }}
            className="w-full bg-[#D62828] py-3 text-sm font-bold uppercase tracking-widest text-white">Book a Demo</button>
        </motion.div>
      )}
    </motion.header>
  );
};
